import React from 'react'
import { ControlledModal } from '../../layouts/components/modal'
import { makeRequest, showAxiosErrorAsToast } from '../../request'
import { Button } from '../../components/simple/button'
import { Toasts } from '../../providers/toast'
import { TextArea } from '../../components/form/textInput'

export const FeedbackModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [loading, setLoading] = React.useState(false)
  const [feedback, setFeedback] = React.useState('')
  return (
    <ControlledModal
      size="sm"
      onOpenChange={(o) => {
        if (!o) onClose()
      }}
      open={true}
      title="Send Feedback"
      disabled={loading}
    >
      <div>We appreciate hearing from you with any feedback, problems, or suggestions!</div>
      <TextArea placeholder="Please type here" className="mt-4 h-32 w-full" value={feedback} onChange={setFeedback} />
      <Button
        logo
        disabled={loading || feedback.trim() === ''}
        className="mt-2 self-start"
        onClick={() => {
          setLoading(true)
          makeRequest<void>('/feedback', { feedback })
            .then(() => {
              Toasts.showToast({ message: 'Feedback sent! Thank you!' })
              onClose()
            })
            .catch(showAxiosErrorAsToast)
            .finally(() => setLoading(false))
        }}
      >
        Send Feedback
      </Button>
    </ControlledModal>
  )
}
